import EmblaCarousel from 'embla-carousel'
import { addNextPrevBtn } from '@/scripts/prevAndNextButtons'
import AutoHeight from 'embla-carousel-auto-height'

class HeroSlider extends HTMLElement {
  constructor () {
    super()

    this.state = {}

    this.handleSlideFocusIn = this.handleSlideFocusIn.bind(this)
    this.resetScrollPosition = this.resetScrollPosition.bind(this)
    this.setup = this.setup.bind(this)
    this.teardown = this.teardown.bind(this)

    this.setup()

    this.parentElement.addEventListener('shopify:section:unload', () => {
      this.teardown()
    })
    this.parentElement.addEventListener('shopify:section:load', () => {
      this.setup()
    })
    this.parentElement.addEventListener('shopify:block:select', (event) => {
      this.embla.scrollTo([...event.target.parentElement.children].indexOf(event.target))
    })
  }

  setup () {
    if (this.querySelectorAll('[data-module="hero"]').length <= 1) {
      return
    }

    const options = { destroyHeight: 'auto' }
    this.embla = EmblaCarousel(this, { loop: false }, [AutoHeight(options)])

    // Lock horizontal scroll for parent element
    this.parentElement.addEventListener('scroll', this.resetScrollPosition)

    // Jump to focused slide when moving with keyboard
    this.addEventListener('focusin', this.handleSlideFocusIn)

    if (this.state.selectedScrollSnap) {
      this.embla.scrollTo(this.state.selectedScrollSnap)
    }

    const prevBtn = this.querySelector('.js-embla-prev')
    const nextBtn = this.querySelector('.js-embla-next')
    const selectedIndexEl = this.querySelector('.js-embla-pagination')
    addNextPrevBtn(prevBtn, nextBtn, this.embla)

    this.embla.on('init', () => {
      setTimeout(() => {
        this.handleVideoPlay(this.embla.selectedScrollSnap() + 1)
      }, 300)
    })

    this.embla.on('select', () => {
      // Pause videos on slide change
      this.handleVideoPlay(this.embla.selectedScrollSnap() + 1)
      selectedIndexEl.innerText = this.embla.selectedScrollSnap() + 1
    })
  }

  handleVideoPlay(index) {
    const backgroundVideos = this.querySelectorAll('background-video')
    const backgroundVideo = this.querySelector(`[data-slide-index="${index}"] background-video`)
    if (backgroundVideo) {
      const htmlVideo = backgroundVideo.querySelector('video')
      const vimeoWrapper = backgroundVideo.querySelector('.vimeo-wrapper')

      backgroundVideos.forEach(videoEl => {
        const video = videoEl.querySelector('video')
        const vimeo = videoEl.vimeoPlayer

        if (video && video.src) video.pause()
        if (vimeo) vimeo.pause()
      })

      if (htmlVideo && htmlVideo.src) {
        backgroundVideo.resume()
      } else if (vimeoWrapper && backgroundVideo.vimeoPlayer) {
        backgroundVideo.vimeoPlayer.play()
      }

      if (htmlVideo && !htmlVideo.src) {
        backgroundVideo.updateSrc()
      }
    }
  }

  teardown () {
    if (this.embla) {
      this.state.selectedScrollSnap = this.embla.selectedScrollSnap
      this.embla.destroy()
      this.parentElement.removeEventListener('scroll', this.handleSlideFocusIn)
      this.removeEventListener('focusin', this.handleSlideFocusIn)
    }
  }

  resetScrollPosition () {
    this.parentElement.scrollTo(0, 0)
  }

  handleSlideFocusIn (event) {
    const slide = event.target.closest('[data-module="hero"]')
    const slideIndex = parseInt(slide.getAttribute('data-slide-index'), 10) - 1

    this.embla.scrollTo(slideIndex, true)
  }
}

customElements.define('hero-slider', HeroSlider)
